import * as React from "react";
import { Heading, Stack, Text } from "@chakra-ui/react";

import IconList from "components/IconList";

const Statistics: React.FC<{ isSelfCheck: boolean }> = ({ isSelfCheck }) => (
  <Stack
    direction={{ base: "column", md: "row" }}
    alignItems={{ base: "center", md: "unset" }}
    spacing={0}
    justify="space-around"
    mb="48px"
  >
    <IconList
      align={isSelfCheck ? "left" : "center"}
      image="/img/icons/exekuce.svg"
      title={isSelfCheck ? "Majitelům na bonitě zájemce záleží" : null}
      body={
        isSelfCheck ? (
          <Text textAlign={{ base: "center", xl: "left" }}>
            Pronajímatelé si na spolehlivosti nájemníků zakládají. Díky
            sebeprověření získáte při oslovování inzerátů velkou konkurenční
            výhodu.
          </Text>
        ) : (
          <Text textAlign="center" variant="large_2">
            <Text fontWeight="bold">
              27 000 +
              <br />
            </Text>
            prověřených osob
          </Text>
        )
      }
    />
    <IconList
      align={isSelfCheck ? "left" : "center"}
      image="/img/icons/zajemci.svg"
      title={
        isSelfCheck ? (
          <Heading as="h3" textAlign={{ base: "center", xl: "left" }}>
            Instantní sebeprověření <br /> v 5 rejstřících
          </Heading>
        ) : null
      }
      body={
        isSelfCheck ? (
          <Text textAlign={{ base: "center", xl: "left" }}>
            Vaše jméno, příjmení a datum narození jsou obratem prověřeny napříč
            5 veřejnými rejstříky v Česku a na Slovensku.
          </Text>
        ) : (
          <Text textAlign="center" variant="large_2">
            <Text fontWeight="bold">
              29,5 %
              <br />
            </Text>
            osob mělo aspoň
            <br /> jeden záznam
          </Text>
        )
      }
    />
    <IconList
      align={isSelfCheck ? "left" : "center"}
      image="/img/icons/smlouvy.svg"
      title={isSelfCheck ? "Výsledky jsou součástí vaší vizitky" : null}
      body={
        isSelfCheck ? (
          <Text textAlign={{ base: "center", xl: "left" }}>
            Zobrazí se tak každému majiteli, kterého kontaktujete. A těm, které
            už jste oslovili, výpis jednoduše dopošlete přes záložku Zprávy.
          </Text>
        ) : (
          <Text textAlign="center" variant="large_2">
            <Text fontWeight="bold">
              200 +
              <br />
            </Text>
            realitních kanceláří <br /> nám důvěřuje
          </Text>
        )
      }
    />
  </Stack>
);

export default Statistics;
